import IHistoricoSaldoInstalacao from "../interfaces/IHistoricoSaldoInstalacao";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class HistoricoSaldoInstalacaoService {
    async getById(id: string) {
        return await api.get<IHistoricoSaldoInstalacao>(`${resources.historicoSaldoInstalacao}/GetById/${id}`);
    }

    async create(data: any) {
        return await api.post<IHistoricoSaldoInstalacao>(`${resources.historicoSaldoInstalacao}/Create`, data);
    }

    async update(data: any) {
        return await api.put<any>(`${resources.historicoSaldoInstalacao}/Update`, data);
    }

    async undo(id: any) {
        return await api.put<any>(`${resources.historicoSaldoInstalacao}/Undo/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.historicoSaldoInstalacao}/GetWithFilter/${ToQueryString(filters)}`);
    }
}

export default new HistoricoSaldoInstalacaoService();
